<template>
  <section class="section">
    <div class="container">
      <StockCompareTabs />
      <slot />
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'StockCompare',
  components: {
    StockCompareFilters: () => import('../components/StockCompareFilters'),
    StockCompareTabs: () => import('../components/StockCompareTabs')
  },
  mounted() {
    this.$mxp.track('stockcompare_dashboard_page_load')

    this.load()
  },
  methods: {
    ...mapActions('stockcompare/dashboard', ['load'])
  }
}
</script>

<style lang="sass">
.card-header
  background: $white
</style>
